import {constructPaypalIdentity } from "../Factory/factory";
import { PAYPAL_IDENTITY } from "../Reducers/paypalIdentityReducer";
import { PAYPAL_IDENTITY_CONNECTED } from "../Reducers/paypalIdentityConnectReducer";
import { initPaypalIdentityConnect } from "../Util/queries";

export const connectPaypalIdentity = (code) => async dispatch => {
    try {
        const response = await initPaypalIdentityConnect({
            authorizationCode: code
        });
        const paypalIdentity = constructPaypalIdentity(
            response.data.email,
            response.data.accountId,
            response.data.name,
            response.data.confirmedAt,
            response.data.verified
        );

        dispatch({
            type: PAYPAL_IDENTITY,
            payload: paypalIdentity,
        });
        dispatch({
            type: PAYPAL_IDENTITY_CONNECTED,
            payload: true,
        })
    } catch (e) {
        console.error(e);
        dispatch({
            type: PAYPAL_IDENTITY_CONNECTED,
            payload: false,
        })
    }
}
